<template lang="pug">
.marketing-upload-brief-completed
  upload-multiple-file(
    text="附件"
    :fileName="data.brief.brief_name"
    :downloadUrl="data.brief.brief_download_url"
    :files="data.brief.brief_name_list"
  )
  el-row
    el-col(:span="4") {{ $t('介绍') }}
    el-col(:span="10")
      display-text-container(:text="data.brief.remark")
  Category(:data="recommendData.selected_scope")
  el-row(v-if='showPhdContact && phdUserName')
    el-col(:span="4") {{ $t('PHD联系人') }}
    el-col(:span="10")
      span {{phdUserName}}
  el-row
    el-col(:span="4") {{ $t('方案上传截止日期') }}
    el-col(:span="10") {{ data.deadline | formatDate }}
  title-bar {{ $t('推荐供应商') }}
  div
    el-row
      el-col(:span="4") {{ $t('推荐供应商') }}
      el-col(:span="10")
        span(v-if="data.is_suggest_vendor === 0 ") {{ $t('否') }}
        template(
          v-for="item in data.campaign_vendor"
        )
          .view-vendors-list
            span {{ item.vendor_name_ch }}/{{ item.vendor_name }}
            span(v-if="item.is_storage === 0" class="non-roster") {{ $t('Non-Roster') }}
            span(v-else-if="item.is_storage === 1" class="roster") {{ $t('Roster') }}
            span(v-else-if="item.is_storage === 2" class="unregistered") {{ $t('Unregistered') }}
            span(v-else-if="item.is_storage === 3" class="unauthorised") {{ $t('Unauthorised') }}
    el-row
      el-col(:span="4") {{ $t('需要采购部推荐供应商') }}
      el-col(:span="10") {{ data.procurement_select_vendor === 0 ? $t('否') : $t('是') }}
    el-row
      el-col(:span="4") {{ $t('备注') }}
      el-col(:span="10")
        display-text-container(:text="recommendData.remark")
</template>

<script>
import TitleBar from '@/components/TitleBar'
import UploadMultipleFile from '@/components/UploadMultipleFile'
import Category from '@/components/Category'
import FooterButton from '@/components/FooterButton'
import { formatDate } from '@/umcc/util'
import DisplayTextContainer from '@/components/DisplayTextContainer'

export default {
  components: {
    TitleBar,
    UploadMultipleFile,
    Category,
    FooterButton,
    DisplayTextContainer
  },
  props: {
    recommendData: {
      type: Object,
      default () {
        return {}
      }
    },
    data: {
      type: Object,
      default () {
        return {
          brief: {}
        }
      }
    },
    showPhdContact: {
      type: Boolean,
      default: false
    },
    phdUserName: {
      type: String,
      default: ''
    }
  },
  filters: {
    formatDate
  }
}
</script>

<style lang="stylus">
.marketing-upload-brief-completed
  margin-left 20px
  .title-bar
    margin-left -20px
</style>
